import { Component } from '@angular/core';
import { SeguroI } from '@app/interfaces/gestion-vehicular/seguro.interface';
import { VehiculoLite } from '@app/interfaces/gestion-vehicular/vehiculo.interface';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-vehiculos-poliza',
  standalone: false,
  templateUrl: './vehiculos-poliza.component.html',
  styleUrl: './vehiculos-poliza.component.scss'
})
export class VehiculosPolizaComponent {
  // * Arreglo con interfaces reales ============
  poliza!: SeguroI;
  vehiculos: VehiculoLite[] = [];

  constructor(public config: DynamicDialogConfig) {
    this.poliza = config.data.poliza;
    this.vehiculos = this.poliza.vehiculos || [];
  }

}
